// extracted by mini-css-extract-plugin
module.exports = {"container":"UniversalSearchStayBanner_container__RhXYF","title":"UniversalSearchStayBanner_title__PRPLg","content":"UniversalSearchStayBanner_content__GHBi4"};